'use client';

import { useState } from 'react';
import { Button, Drawer, Heading } from '@petsmart-ui/sparky';
import { ProductHit } from '@libs/algolia';
import { clsx } from '@libs/common-next';
import { Product } from './types';
import './SetUpAutoshipButton.scss';

interface SetUpAutoshipButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    product: Product | ProductHit;
    className: string;
}

export function SetUpAutoshipButton({ product, className, ...props }: Readonly<SetUpAutoshipButtonProps>) {
    const [addedToCart] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    return (
        <>
            <div className={className}>
                <Button
                    type="submit"
                    variant="primary"
                    text={addedToCart ? 'Edit Autoship' : 'Set Autoship'}
                    className={clsx(addedToCart && 'add-to-cart-button add-to-cart-button__green')}
                    iconName="autoship-outline"
                    onClick={openDrawer}
                    {...props}
                />
            </div>
            <Drawer
                key={product.id}
                isActive={isDrawerOpen}
                onClose={closeDrawer}
                align="right"
                ariaLabelledBy="drawer-heading"
                className="personalize-drawer"
                data-testid="autoship-atc-drawer"
            >
                <Drawer.Header>
                    <Heading id="drawer-heading" tagName="h2" size="headline" className="personalize-drawer-header">
                        Autoship
                    </Heading>
                </Drawer.Header>
            </Drawer>
        </>
    );
}
